import { render, staticRenderFns } from "./forceLogin.vue?vue&type=template&id=2a4d2a9c&scoped=true"
import script from "./forceLogin.vue?vue&type=script&lang=js"
export * from "./forceLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4d2a9c",
  null
  
)

export default component.exports